const userProspect = 'user-prospect'
import axios from 'axios'

export default {
  addProspect (context, body) {
    axios.post(userProspect, body).then((response) => {
      context.$vs.loading.close()
      context.isLoading = false
      context.prospectAdded(response.data)
    }, (error) => {
      context.$vs.loading.close()
      context.isLoading = false
      context.prospectNotAdded(error.response.data.return_message)
    })
  },
  makePayment (context, id, body) {
    axios.put(`${userProspect}/${id}/payment`, body).then((response) => {
      context.$vs.loading.close()
      context.isLoading = false
      context.paymentCompleted(response.data)
    }, (error) => {
      context.$vs.loading.close()
      context.isLoading = false
      console.log('return_message', error.response.data.return_message)
      context.paymentNotCompleted(error.response.data.return_message)
    })
  },
  backgroundCheck (context, id, body) {
    axios.put(`${userProspect}/${id}/background-check`, body).then((response) => {
      context.$vs.loading.close()
      context.isLoading = false
      context.paymentCompleted(response.data)
    }, (error) => {
      context.$vs.loading.close()
      context.isLoading = false
      context.paymentNotCompleted(error.response.data.return_message)
    })
  }

}